import { baseApi } from '@/lib/api/baseApi';

import type { Builder } from '../commonApiType/apiBuilderTypes';

export const existingEmailApi = baseApi.injectEndpoints({
  endpoints: (builder: Builder) => ({
    emailExists: builder.mutation({
      query: credentials => ({
        url: '/appmanagement/optimize/v1/public/user/email/exists',
        method: 'POST',
        body: credentials,
      }),
      transformResponse: response => response,
      invalidatesTags: [{ type: 'existingEmail', id: 'LIST' }],
    }),
  }),
  overrideExisting: false,
});
